import React, { Component } from 'react';

class StudioTour extends Component {
  render() {
    return (
        <section className="studioTour" id="studiotour">
            <div className="st-container">
                <div className="map-section" >
                    <div className="st-heading-desktop margin-container-sm">
                        <h1 className="h2">Welcome to the 18th annual Studio Tour</h1>
                        <p>Use the embedded map of the area to locate each studio. Studios may have a single artist or house several artists.</p>
                    </div>
                    <iframe
                    className="studioTour-map"
                    title="google map with events for studio tour"
                    src="https://www.google.com/maps/d/u/0/embed?mid=1B6aGKcG6JMUSeZaWy519mxWeI_9zMz0&ehbc=2E312F&noprof=1"
                    ></iframe>
                </div>
                <div className="brochure-section">
                    <div className="st-heading-mobile margin-container-sm">
                        <h1 className="h2">Welcome to the 18th annual Studio Tour</h1>
                        <p>Use the embedded map of the area to locate each studio. Studios may have a single artist or house several artists.</p>
                    </div>
                    <div className="margin-container-sm">
                        <div className="brochure-wrapper">
                            <a href="https://talart.org/uploads/studiotour/digital-brochure-studio-tour-2025.pdf" target="_blank" rel="noreferrer">
                                <img src="https://talart.org/uploads/studiotour/brochure-cover.jpg" alt="studio tour brochure cover" />
                            </a>
                        </div>
                        <a href="https://talart.org/uploads/studiotour/digital-brochure-studio-tour-2025.pdf" target="_blank" rel="noreferrer">
                            View the 2025 Studio Tour Brochure
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
  }
}

export default StudioTour;